import styled from "@emotion/styled";

export const Article = styled.article`
  max-inline-size: 1560px;
`;
